enum RouteUrl {
  Root = '/',
  Error = '/error',
}

export default RouteUrl;
